import request from '../utils/request'
import qs from 'qs'
/**
 * 登录
 * @param params
 */
export const loginAPI = (params: any) => request.post('/sys/login', qs.stringify(params))
/**
 * 登出
 */
export const logoutAPI = () => request.post('/sys/logout')
/**
 * 获取用户信息
 */
export const getUserInfoAPI = () => request.get('/user/getUserInfoByToken')
/**
 * 修改密码
 */
export const getUpdatePwdAPI = (params:{oldPassWord:string,password:string}) => request.post('user/changePassword',qs.stringify(params))
/**
 * 修改姓名
 */
export const getUpdateNameAPI = (params:{displayName:string}) => request.post('user/changePassword',qs.stringify(params))
/**
 * 修改电话号
 */
export const getUpdatePhoneAPI = (params:{phone:string}) => request.post('user/changePassword',qs.stringify(params))
